import styled from 'styled-components';

export const OnboardingTPVContent = styled.div`
  text-align: left;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
  margin-top: 16px;
`;

export const ContentList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const ContentItem = styled.li`
  font-size: 16px;
  font-weight: 300;
  margin-bottom: 16px;
`;

export const HorizontalLine = styled.div`
  width: 100%;
  height: 0px;
  margin: 0;
  align-self: center;
  border-top: 1px solid ${({ theme }) => theme.colors.backgroundInteractionPressedSecondary4100};
`;

export const DividerWrapper = styled.div`
  display: flex;
  h2 {
    min-width: 76px;
  }
`;

export const AgentScheduleContainer = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    width: 292px;
    align-items: center;
    font-size: 16px;
    color: ${theme.colors.textSecondaryGrey90};
    padding: 0 21px 0 24px;
    max-width: 292px;
    margin-top: 24px;

    div {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-top: 8px;
      div {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 0 0 4px 0;
      }
    }
  `}
`;

export const OnboardingTPVContainer = styled.div`
  width: 100%;
  max-width: 488px;
  display: flex;
  flex-direction: column;
  align-items: center;

  button {
    min-width: 256px;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.small}) {
    max-width: 288px;

    h2 {
      margin: 12px;
    }

    ${OnboardingTPVContent} {
      margin-top: 12px;
      li {
        margin-bottom: 12px;
      }
    }

    ${AgentScheduleContainer} {
      padding: 0;
      align-items: flex-start;
      margin-top: 20px;
    }
  }
`;

export const TPVUnverifiedContainer = styled(OnboardingTPVContainer)`
  strong {
    font-weight: 700;
  }

  > svg {
    position: relative;
    left: 14px;
  }
`;

export const TPVVerifiedContainer = styled(OnboardingTPVContainer)`
  ${({ theme }) => `

    margin-top: 86px;

    h1 {
      max-width: 415px;
    }

    svg {
      left: 0;
    }

    @media screen and (max-width: ${theme.breakpoints.medium}) {
      h1 {
        font-weight: 500;
        margin-bottom: 0;
      }
      p {
        margin-bottom: 84px;
      }
    }

    @media screen and (max-width: ${theme.breakpoints.small}) {
      margin-top: 24px; 
      p {
        margin-bottom: 20px;
      }
    }
  `}
`;

export const TPVFailedContainer = styled(TPVVerifiedContainer)`
  button svg {
    position: relative;
    top: 2px;
  }
`;

export const TPVSupportHours = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    margin-bottom: 48px;
    font-size: 16px;

    p {
      text-align: center;
      margin: 0;
    }

    @media screen and (max-width: ${theme.breakpoints.medium}) {
      margin-bottom: 24px;
    }
    @media screen and (max-width: ${theme.breakpoints.small}) {
      margin-bottom: 20px;
    }
  `}
`;
